"use client";

import { Suspense, useEffect, useState } from "react";
import InfoDefault from "./infoDefault";
import useModalStore, { useIsAppState } from "./store/useModalStore";
import { usePathname } from "next/navigation";
import { BLUR_DATAURL } from "./constants";
import Image from 'next/image';
// import { useSession } from "next-auth/react";
import BackButton from "./component/back_button";
import IndexButton from "./component/index_button";
import Navigation from "./component/navigation";

export default function Sublayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {

  const currentPage = usePathname();

  const blankPageUrls = ["/hotel"];
  const notNavigatorUrls = ["/"];
  const bottomNotFullUrls = ["/select_hotel"];  // 오른쪽 화면 full 안 되는 url

  const useIsApp = useIsAppState();
  // const { data: session } = useSession();

  const env = process.env.NODE_ENV;
  if (env == "development") {
    // console.log("development");
  }
  else if (env == "production") {
    // console.log("production");
  }

  useEffect(() => {
    if (window.flutter_inappwebview?.callHandler) {
      window.flutter_inappwebview.callHandler('isApp')
        .then(function (result: boolean) {
          if (result) {
            useModalStore.setState({ isApp: true });
          }
        });
    }

    const env = process.env.NODE_ENV
    if (env == "production") {
      componentDidMount();
    }

  }, []);

  // 마우스 우클릭 방지
  const componentDidMount = () => {
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  };

  // const renderNavigaitor = () => {
  //   return <>
  //     <div className="sticky z-10 top-0 p-3 flex items-center justify-between bg-white border-b border-neutral-300 dark:border-neutral-700">
  //       {notNavigatorUrls.includes(currentPage) ?
  //         <div>
  //           <Image
  //             src="/images/logo.png"
  //             alt="투어캐스트"
  //             width="0"
  //             height="0"
  //             sizes="100vw"
  //             className="w-36 h-auto"
  //             loading="lazy"
  //             placeholder="blur"
  //             blurDataURL={BLUR_DATAURL}
  //           />
  //         </div>
  //         :
  //         <Suspense>
  //           <BackButton />
  //         </Suspense>
  //       }

  //       <div className="flex items-center	">
  //         <Suspense>
  //           <IndexButton />
  //         </Suspense>

  //         {/* 로그인 버튼 */}
  //         {/* {session?.user != null ? <button
  //                   className="focus:outline-none w-16 h-10 rounded-md flex items-center justify-center hover:bg-neutral-100"
  //                 >
  //                   로그아웃
  //                 </button> : <button
  //                   className="focus:outline-none w-16 h-10 rounded-md flex items-center justify-center hover:bg-neutral-100"
  //                 >
  //                   로그인
  //                 </button>} */}
  //       </div>
  //     </div>
  //   </>;
  // }

  const renderContents = () => {
    return <>
      <div className={`md:relative left-1/4 transform -translate-x-1/5 bg-white pb-8 shadow-xl ring-1 ring-gray-900/5 sm:rounded-lg max-w-md mx-auto`}>
        <div className="">
          {/* <div className="divide-y divide-gray-300/50 min-h-screen"> */}
          <div className={bottomNotFullUrls.includes(currentPage) ? "" : "min-h-screen"}>
            <div className="pb-8 text-base leading-7 text-gray-600 relative">
              {/* <CheckScroll /> */}

              {/* {useIsApp ? <></> : <Navigation />} */}
              <Suspense>
                <Navigation />
              </Suspense>

              {children}

            </div>
          </div>
        </div>
      </div>
    </>;
  }

  return <>
    {/* 배경이미지 */}
    {blankPageUrls.includes(currentPage) ? <>
      {children}
    </> :
      <div className="bg-main bg-fixed">
        {/* <NicknameModal /> */}
        <div className="relative items-start">
          {/* 메인 부분 - pc 에서만 보임 */}
          <InfoDefault />

          {/* 콘텐츠 영역 */}
          <div onCopy={(event) => {
            if (env == "production") {
              event.preventDefault();
              alert("컨텐츠 보호를 위해 복사하기 기능은 사용할 수 없습니다.");
            }
          }}>
            {renderContents()}
          </div>
        </div>
      </div>
    }
  </>;
}


